import { render, staticRenderFns } from "./KVStoreTable.vue?vue&type=template&id=16e80bb2"
import script from "./KVStoreTable.vue?vue&type=script&lang=js"
export * from "./KVStoreTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports